import type { Item } from "../common";

export enum InsightPackagesFilterField {
    BRAND = "PACKAGED_BRAND",
    BROWSE_NODE = "PACKAGED_BROWSE_NODE",
    OBJECTIVE = "PACKAGED_OBJECTIVE",
}

export type InsightPackagesFilterSelections = {
    [key in InsightPackagesFilterField]: Item[];
};
export type InsightPackagesFilterOptions = {
    [key in InsightPackagesFilterField]: Item[];
};
